export const panelAnimationDuration = 300;

export const panelDefaultAnimationStyle = {
  transitionProperty: 'opacity',
  transitionDuration: `${panelAnimationDuration}ms`,
  transitionTimingFunction: 'ease-in-out',
  opacity: 1,
};

export const panelAnimationTransitionStyles = {
  entering: {
    opacity: 1,
  },
  entered: {
    opacity: 1,
    position: 'relative',
  },
  exiting: {
    opacity: 0,
  },
  exited: {
    opacity: 0,
  },
};
